<template>
  <div class="TimeEvent">
    <div class="time" :style="inputColor">
      <div class="year">{{time.year}}</div>
      <div class="date">{{time.date}}</div>
    </div>
    <div class="event">
      <my_image class="arrow" :src="arrow" :width="imgWidth"></my_image>
      <div class="main">{{event.main}}</div>
      <div class="sub">{{event.sub}}</div>
    </div>
  </div>
</template>

<script>
 import MyImage from '@/components/Image.vue';
 import Arrow from '@/assets/image/frontpage/arrow-bottom.png';
 export default {
   name: 'TimeEvent',
   props: ['event', 'time', 'color'],
   computed: {
     imgWidth () {
       return this.$store.state.mediaPhone? '2vw': '1.35vw'
     },
     arrow () {
       return Arrow
     },
     inputColor () {
       return {
         'background-color': this.color
       }
     }
   },
   components: {
     my_image: MyImage
   }
 }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
 .TimeEvent{
   color: white;
   display: flex;
   flex-direction: column;
   align-items: center;
 }
 .time{
   width: 7.76vw;
   height: 5vw;
   border-radius: 0.5vw;
   display:flex;
   flex-direction: column;
   align-items: center;
   justify-content: center;
 }
 .time .year{
   font-size: 0.9vw;
 }
 .time .date{
   font-size: 1.15vw;
 }
 .event{
   width: 8.65vw;
   height: 6vw;
   overflow: visible;
   display: flex;
   flex-direction: column;
   align-items: center;
 }
 .event .arrow{
   margin-top: 1.25vw;
 }
 .event .main{
   margin-top: 0.625vw;
   font-size: 1.04vw;
   white-space: nowrap;
 }
 .event .sub{
   margin-top: 0.4vw;
   font-size: 0.9vw;
 }


@media (min-width: 320px) and (max-width: 480px) {
 .time{
   width: 12vw;
   height: 7.73vw;
   border-radius: 0.5vw;
 }
 .time .year{
   font-size: 1.6vw;
 }
 .time .date{
   font-size: 2.1vw;
 }
 .event{
   width: 13.38vw;
   height: 9.28vw;
 }
 .event .arrow{
   margin-top: 1.25vw;
 }
 .event .main{
   margin-top: 0.625vw;
   font-size: 2.08vw;
 }
 .event .sub{
   margin-top: 0.4vw;
   font-size: 1.7vw;
 }


 }

</style>
